module.exports = __webpack_public_path__ + "static/media/xilinx.18772c92.png";